import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// /discounts loads DiscountsEntry only. App (and its auth setup) stays on other routes.
function isDiscountsPath(pathname: string): boolean {
  return pathname === '/discounts' || pathname.startsWith('/discounts/');
}

const entry = isDiscountsPath(window.location.pathname)
  ? import('./DiscountsEntry')
  : import('./App');

entry.then((mod) => {
  const Page = mod.default;
  root.render(
    <React.StrictMode>
      <Page />
    </React.StrictMode>
  );
});

reportWebVitals();
